module.exports = __webpack_public_path__ + "img/udacity.ff89e127.svg";